<script setup lang="ts">

import { tma_open_tg_link } from '@/utils/shared';

const main_store = useMainStore();

const auth_store = useAuthStore();

const { locales, setLocale, locale, t } = useI18n()

const has_active_card = computed(() => auth_store?.blue_c_state?.status === 'active')

type LocaleCode = 'en' | 'ru';

const toast = useToast();

async function open_card() {
	main_store.is_top_menu_modal_visible = false
	await navigateTo('/card-blue')
}

async function open_guide() {
	main_store.is_top_menu_modal_visible = false
	await navigateTo('/guide')
}

async function update_user_language(code: LocaleCode) {
	
	if (auth_store?.user?.language_code == code) return;

	try {
		const response_data = await auth_store.update_user_language(code);

		if (response_data?.success) {
			await setLocale(code);
			useDayjs().locale(code)

			toast.add({
				title: t('language_setuped'),
				color: 'green',
			});

		} else {
			console.error('Error updating user language:', response_data);

			toast.add({
				title: t('language_update_error'),
				color: 'red',
			});
		}

	} catch (e) {
		console.error('Error updating user language:', e);

		toast.add({
			title: t('language_update_error'),
			color: 'red',
		});
	}
	
	
}

</script>

<template>
<UModal v-model="main_store.is_top_menu_modal_visible" :ui="{ padding: 'p-0', background: 'bg-transparent' }" fullscreen>
	<div class="flex h-screen bg-black/30" @click.self="main_store.is_top_menu_modal_visible = false">
		<aside class="stark-menu h-full w-[86%] max-w-sm overflow-auto px-5 pb-8 pt-[calc(20px+env(safe-area-inset-top))] shadow-2xl">
			<div class="mb-10 flex items-center justify-between">
				<div>
					<p class="m-0 text-[11px] font-bold tracking-[0.12em] text-stark-gold-500">STARK</p>
					<h2 class="stark-menu-title mt-1 text-2xl font-bold tracking-tight">{{ auth_store?.user?.tg?.first_name || $t('card') }}</h2>
				</div>
				<button class="stark-icon-button" type="button" aria-label="Close menu" @click="main_store.is_top_menu_modal_visible = false"><UIcon name="i-heroicons-x-mark-20-solid" class="h-6 w-6" /></button>
			</div>

			<p class="stark-menu-section mb-3 text-[11px] font-bold tracking-[0.1em]">{{ locale === 'ru' ? 'КАРТА И СЕРВИС' : 'CARD & SERVICE' }}</p>
			<div class="stark-menu-list overflow-hidden rounded-[18px] border">
				<button v-if="has_active_card" class="stark-menu-item flex w-full items-center justify-between px-4 py-4 text-left" type="button" @click="open_card">
					<span class="stark-menu-item-content flex items-center gap-3 font-semibold"><UIcon name="i-tabler-credit-card" class="h-5 w-5 text-stark-gold-500" />{{ $t('card') }}</span>
					<UIcon name="i-heroicons-chevron-right-20-solid" class="stark-menu-chevron h-5 w-5" />
				</button>
				<div v-if="has_active_card" class="stark-menu-divider mx-4 h-px"></div>
				<button class="stark-menu-item flex w-full items-center justify-between px-4 py-4 text-left" type="button" @click="open_guide">
					<span class="stark-menu-item-content flex items-center gap-3 font-semibold"><UIcon name="i-mdi-book-open-page-variant" class="h-5 w-5 text-stark-gold-500" />{{ $t('rukovodstvo-polzovatelya') }}</span>
					<UIcon name="i-heroicons-arrow-up-right-20-solid" class="stark-menu-chevron h-5 w-5" />
				</button>
				<div class="stark-menu-divider mx-4 h-px"></div>
				<button class="stark-menu-item flex w-full items-center justify-between px-4 py-4 text-left" type="button" @click="tma_open_tg_link(auth_store?.project_config?.tg_support_account_url || '')">
					<span class="stark-menu-item-content flex items-center gap-3 font-semibold"><UIcon name="i-mdi-chat-question" class="h-5 w-5 text-stark-gold-500" />{{ $t('podderzhka') }}</span>
					<UIcon name="i-heroicons-arrow-up-right-20-solid" class="stark-menu-chevron h-5 w-5" />
				</button>
			</div>

			<p class="stark-menu-section mb-3 mt-8 text-[11px] font-bold tracking-[0.1em]">{{ locale === 'ru' ? 'ЯЗЫК' : 'LANGUAGE' }}</p>
			<div class="grid grid-cols-2 gap-3">
				<button v-for="locale_item in locales" :key="locale_item.code" class="stark-menu-language rounded-2xl border px-4 py-3 text-left font-semibold" :class="{ 'is-active': locale_item.code === locale }" type="button" @click="update_user_language(locale_item.code)">
					{{ locale_item.code === 'ru' ? 'Русский' : 'English' }}
				</button>
			</div>

		</aside>
	</div>

	<!-- <UCard :ui="{ ring: '', divide: 'divide-y divide-gray-100 dark:divide-gray-800', rounded: 'rounded-xl' }">
		<template #header>
		  <div class="flex items-center justify-between">
			<h3 class="text-base font-semibold leading-6 text-gray-900 dark:text-white">
				Условия и лимиты по карте
			</h3>
			<UButton color="gray" variant="ghost" icon="i-heroicons-x-mark-20-solid" class="-my-1" @click="main_store.is_top_menu_modal_visible = false" />
		  </div>
		</template>

		<div class="pb-6">

			<ol class="list-decimal space-y-2 px-6">
				<li v-for="(item, index) in card_conditions_info_items" :key="index">
					<div v-html="item"></div>
				</li>
			</ol>

		</div>
		
	</UCard> -->

</UModal>
</template>
